/* eslint-disable */
import classnames from 'classnames'
import dateformat from 'dateformat'
import { includes } from 'lodash'
import PropTypes from 'prop-types'
import React from 'react'

import EmailCallout from 'components/email-callout'
import ImageWithPlaceholderColor from 'components/image-with-placeholder-color'
import Loader from 'components/loader'
import Pinnable from 'shared/pinnable'
import ShareButtons from 'shared/share-buttons'
import * as blUrls from 'lib/urls'

import Link from 'components/link'
import TopicList from '../topic-list'
import Author from '../author'
import PostCardRow from '../post-card-row'
import PostLink from '../post-link'
import css from './post-view.scss'
import PostNavBar from './post-nav-bar'
import PostSocialButtons from './post-social-buttons'
import { SectionHeading } from '../../../components/headings'
import { tracking, track, TrackImpression } from 'lib/analytics'
import FTCDisclosureTag from '../../../components/FTCDisclosureTag'
import SignUpBanner from './SignUpBanner'

const READ_LANGUAGE_LABEL = { 'es-US': 'En Español', 'en-US': 'In English' }

@tracking(({ post }) => ({ post }))
export default class PostView extends React.Component {
  static propTypes = {
    popularPosts: PropTypes.array,
    post: PropTypes.object.isRequired,
    relatedPosts: PropTypes.array,
    nextPost: PropTypes.object,
    previousPost: PropTypes.object,
    emailUrls: PropTypes.object,
  }

  static contextTypes = {
    minimalView: PropTypes.bool,
  }

  constructor(props) {
    super(props)

    this.state = {
      isUserLoggedIn: false,
      showSignUpBanner: !this.isUserLoggedIn(),
    }
  }

  isUserLoggedIn = () => {
    if (typeof window !== 'undefined') {
      return !!window.currentUser
    }

    return false
  }

  render() {
    const { post, relatedPosts, nextPost, previousPost, emailUrls } = this.props
    const shareProps = post.socialShareUrl
      ? {
          description: post.meta ? post.meta.socialDescription : null,
          media:
            (post.meta && post.meta.pinterestImageUrl) ||
            (post.featuredImage && post.featuredImage.url) ||
            null, // should never be null because featuredImage is required
          url: post.socialShareUrl,
        }
      : null

    return post.body ? (
      <TrackImpression eventProperties={{ event: track.guideViewed }}>
        <PostNavBar
          title={post.title}
          nextPost={nextPost}
          previousPost={previousPost}
        >
          <div className={css.post}>
            <div ref={(ref) => (this.postContainer = ref)}>
              <div className={css.wrapper}>
                <PostSocialButtons
                  {...shareProps}
                  container={() => this.postContainer}
                />

                <div className={css.meta}>
                  <span className={css.publishedAt}>
                    {dateformat(post.publishedAt, 'mmmm d, yyyy')}
                  </span>
                  <TopicList
                    topics={post.meta.topics}
                    className={classnames(css.topics, 'hidden-xs')}
                  />
                  <div className={classnames(css.languages)}>
                    {post.locales.map((l) => {
                      const text = READ_LANGUAGE_LABEL[l.locale]
                      return text ? (
                        <i key={l.slug}>
                          <Link url={l.slug} className="language-link h6 mvn">
                            {text}
                          </Link>
                        </i>
                      ) : null
                    })}
                  </div>
                </div>

                <div className="breakout-right">
                  <SectionHeading className={css.title}>
                    {post.title}
                  </SectionHeading>
                  {post.teaser && (
                    <div className={css.postTeaser}>{post.teaser}</div>
                  )}
                </div>
                <FTCDisclosureTag
                  align="left"
                  className="mbl"
                  disclaimerContext={FTCDisclosureTag.Constants.GUIDE}
                />

                {this.renderFeaturedAsset('mbxl ptl')}

                <div className={classnames(css.body)}>
                  <div
                    dangerouslySetInnerHTML={{ __html: post.body }}
                    className="guides-markdown"
                  />

                  {!this.context.minimalView && (
                    <ShareButtons
                      className="mbxl"
                      shareText="Share"
                      {...shareProps}
                    />
                  )}

                  {post.author ? <Author author={post.author} /> : null}

                  <small className="h7 mvxl">
                    {/* eslint-disable-next-line */}
                    {/* prettier-ignore */}
                    This information is provided for educational and
                    entertainment purposes only. We do not accept any
                    responsibility for any liability, loss or risk, personal or
                    otherwise, incurred as a consequence, directly or
                    indirectly, from any information or advice contained here.
                    Babylist may earn compensation from affiliate links in this
                    content. Learn more about
                    {` `}
                    <Link url={blUrls.helloBabyPostPath('about-us')}>
                      how we write Babylist content
                    </Link>{' '}
                    and the{' '}
                    <Link url={blUrls.healthAdvisoryBoardPath}>
                      Babylist Health Advisory Board
                    </Link>
                    .
                  </small>
                </div>
              </div>

              {previousPost && nextPost && !this.context.minimalView && (
                <div className="mbxl">
                  <div className={css.postLink}>
                    <PostLink direction="left" post={previousPost} />
                  </div>
                  <div className={classnames(css.postLink)}>
                    <PostLink direction="right" post={nextPost} />
                  </div>
                </div>
              )}
            </div>
          </div>

          {!this.context.minimalView ? (
            <div>
              {includes(
                post.meta.topics.map((topic) => topic.slug),
                'pregnancy'
              ) ? (
                <EmailCallout
                  emailType={BLConstants.EMAIL_USER_PREGNANCY}
                  emailUrlsByWeek={emailUrls}
                />
              ) : (
                <EmailCallout
                  emailType={BLConstants.EMAIL_USER_NEWSLETTER}
                  nextPost={nextPost}
                />
              )}
            </div>
          ) : null}

          {!this.context.minimalView && (
            <div className="related-posts-container-wrapper">
              <div className="container">
                <div className="h3 section-heading text-bold mtn">
                  Related Articles
                </div>
                <PostCardRow showTopics posts={relatedPosts} className="mtl" />
              </div>
            </div>
          )}

          {!this.context.minimalView && (
            <>
              {!this.state.isUserLoggedIn && (
                <SignUpBanner
                  onClose={() => {
                    this.setState({ showSignUpBanner: false })
                  }}
                  show={this.state.showSignUpBanner}
                />
              )}
            </>
          )}
        </PostNavBar>
      </TrackImpression>
    ) : (
      <div
        style={{ minHeight: '100vh', position: 'relative', marginTop: '-11vh' }}
      >
        <Loader className="center-xy" />
      </div>
    )
  }

  renderFeaturedAsset(assetClasses = '') {
    const { post } = this.props
    if (post.videoId) {
      return (
        <div className="breakout-right">
          <div
            className={classnames(
              'embed-responsive embed-responsive-16by9',
              assetClasses
            )}
          >
            <iframe
              className="embed-responsive-item"
              src={`https://www.youtube.com/embed/${post.videoId}`}
              frameBorder="0"
              allowFullScreen
            />
          </div>
        </div>
      )
    }
    const image = (
      <ImageWithPlaceholderColor
        aspectWidth={3}
        aspectHeight={2}
        alt={post.featuredImage.description}
        data-pin-no-hover="true"
        src={post.featuredImage.url}
      />
    )
    return (
      <div className={assetClasses}>
        {this.context.minimalView ? (
          <>{image}</>
        ) : (
          <Pinnable
            buttonSize="large"
            description={post.meta.socialDescription}
            media={post.featuredImage.url}
            url={post.socialShareUrl}
          >
            {image}
          </Pinnable>
        )}

        {post.featuredImage.attribution ? (
          <div className="h7 mts post-featured-image-attribution">
            {`Photo by `}
            {post.featuredImage.attributionUrl ? (
              <a href={post.featuredImage.attributionUrl} target="_blank">
                {post.featuredImage.attribution}
              </a>
            ) : (
              post.featuredImage.attribution
            )}
          </div>
        ) : null}
      </div>
    )
  }
}
